import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import '../../App.css';
import { styled } from '../../components/styled';
import SpText from '../../components/atoms/SpText';
import SpDialog from '../../components/atoms/SpDialog';
import SpButton from '../../components/atoms/SpButton';
import { ArrowBack, DeleteForever } from '@material-ui/icons';
import moment from 'moment';
import { Button as MuiButton, FormControlLabel, Grid, Radio, TableCell } from '@material-ui/core';
import { withSnackbar } from '../../components/atoms/SpSnackBar';
import { theme as themeStyle } from '../../components/theme';
import { findStationById } from '../../models/actions/Stations';
import { findReportsByStationId, updateReport } from '../../models/actions/Reports';
import { theme } from '../../components/theme';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import StationOpenReports from '../stations/stationReports/stationReportsTabs/StationOpenReports';
import StationClosedReports from '../stations/stationReports/stationReportsTabs/StationClosedReports';
import StationClosedReportDetailDialog from './stationReports/stationReportDetail/StationClosedReportDetailDialog';
import StationOpenedReportDetailDialog from './stationReports/stationReportDetail/StationOpenedReportDetailDialog';
import { UserSessionContext } from '../../App';

//Tabs to be local to the component
const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent'
  },
  '& .MuiTabs-indicatorSpan': {
    maxWidth: 40,
    width: '100%',
    backgroundColor: '#FFF'
  }
});

const StyledTab = styled((props) => (
  <Tab
    disableRipple
    {...props}
  />
))(({ theme }) => ({
  textTransform: 'none',
  fontSize: '1.15rem',
  fontWeight: 600,
  marginRight: theme.spacing(1),
  color: 'rgba(255, 255, 255, 0.7)',
  '&.Mui-selected': {
    color: '#fff',
    fontSize: '1.25rem',
    fontWeight: 600
  },
  '&.Mui-focusVisible': {
    backgroundColor: '#FFF'
  }
}));

const SpTab = ({ valueTab: value, setValueTab: setValue, setSelectedReportDetailClosed, reportsList, setSelectedReportDetailOpen, setCloseReportDialog, handleSubmit, register }) => {
  const tabLabels = [
    { id: 0, label: 'Segnalazioni aperte' },
    { id: 1, label: 'Segnalazioni chiuse' }
  ];
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ bgcolor: 'rgb(77, 172, 39, 0.8)' }}>
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="styled tabs example"
        >
          {tabLabels.map((elem) => (
            <StyledTab
              label={elem.label}
              onClick={() => setValue(elem.id)}
            />
          ))}
        </StyledTabs>
        <div>
          {value === 0 && (
            <div
              value={value}
              role="tabpanel"
            >
              <StationOpenReports
                index={0}
                {...{ setCloseReportDialog, reportsList, handleSubmit, register, setSelectedReportDetailOpen }}
              />
            </div>
          )}
          {value === 1 && (
            <div
              value={value}
              role="tabpanel"
            >
              <StationClosedReports
                index={1}
                {...{ setSelectedReportDetailClosed }}
              />
            </div>
          )}
        </div>
      </Box>
    </Box>
  );
};

const TitleToolbarSection = styled('div')({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'flex-start'
});

const StationReports = (props) => {
  const [currentStation, setCurrentStation] = useState();
  const [closeReportDialog, setCloseReportDialog] = useState({ report: null, status: false });
  const [selectedReportDetailOpen, setSelectedReportDetailOpen] = useState({ report: null, status: false });
  const [selectedReportDetailClosed, setSelectedReportDetailClosed] = useState({ report: null, status: false });
  const [reportsList, setReportsList] = useState([]);
  const [valueTab, setValueTab] = useState(0);
  const { authData, setAuthData } = useContext(UserSessionContext);

  const { stationId } = useParams();
  const history = useHistory();

  const { getValues, register, setValue, handleSubmit, reset } = useForm({
    shouldUnregister: false,
    name: 'report'
  });

  const fetchData = async () => {
    if (stationId) {
      try {
        props.isLoading(true);
        const responseStation = await findStationById({ id_station: stationId }, authData.accessToken);
        responseStation && setCurrentStation(responseStation);
        props.isLoading(false);
      } catch (error) {
        props.isLoading(false);
        props.snackbarShowErrorMessage(error);
      }
    }
  };

  const updateCurrentReport = (data) => {
    try {
      const responseUpdate = updateReport({ ...data }, authData.accessToken);
      if (responseUpdate) {
        props.snackbarShowMessage(responseUpdate.message);
        setSelectedReportDetailOpen({ report: null, status: false });
        fetchData();
      }
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
  };

  const forcedReportEnding = async () => {
    try {
      props.isLoading(true);
      let newReportData = closeReportDialog.report;
      newReportData.status = 'close';
      const responseReportEnding = await updateReport({ report: newReportData }, authData.accessToken);
      if (responseReportEnding.message) {
        props.snackbarShowMessage(responseReportEnding.message);
        setCloseReportDialog({ report: null, status: false });
        await fetchData();
      } else {
        props.snackbarShowErrorMessage(responseReportEnding.error);
      }
      props.isLoading(false);
    } catch (error) {
      props.isLoading(false);
      props.snackbarShowErrorMessage(error);
    }
  };

  const updateReportData = async () => {
    try {
      props.isLoading(true);
      const responseReportEnding = await updateReport({ ...selectedReportDetailOpen.report }, authData.accessToken);
      if (responseReportEnding.message) {
        props.snackbarShowMessage(responseReportEnding.message);
        setCloseReportDialog({ report: null, status: false });
        await fetchData();
      } else {
        props.snackbarShowErrorMessage(responseReportEnding.error);
      }
      props.isLoading(false);
    } catch (error) {
      props.isLoading(false);
      props.snackbarShowErrorMessage(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Grid
        style={{ paddingLeft: '1%' }}
        direction="column"
        container
        spacing={2}
      >
        {stationId && (
          <Grid
            item
            container
            xs={12}
            spacing={1}
            justifyContent="flex-end"
          >
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Ebike'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push({ pathname: `/stations/edit/${stationId}/ebikes`, state: { stationData: getValues() && stationId ? getValues() : currentStation } })}
              />
            </Grid>
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Noleggi'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/stations/edit/${stationId}/rents`)}
              />
            </Grid>
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Prenotazioni'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/stations/edit/${stationId}/reservations`)}
              />
            </Grid>
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Segnalazioni'}
                style={{ maxWidth: '40%', backgroundColor: theme.colors.mainGreen.secondary, color: 'white' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/stations/edit/${stationId}/reports`)}
              />
            </Grid>
          </Grid>
        )}
        <Grid
          item
          container
          xs={12}
          justifyContent="space-between"
        >
          <Grid
            item
            xs={8}
          >
            <TitleToolbarSection>
              <ArrowBack
                onClick={() => history.push('/stations')}
                style={{ width: 25, color: themeStyle.colors.mainGreen.secondary, height: 50, cursor: 'pointer' }}
              />
              <SpText
                variant="breadcrumbs"
                style={{ marginRight: '5px' }}
              >
                {`Home / Stazione / ${currentStation?.name} / Segnalazioni `}
              </SpText>
            </TitleToolbarSection>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          container
          spacing={3}
          direction="column"
        >
          <Grid
            item
            xs={12}
          >
            <SpTab {...{ valueTab, setValueTab, setSelectedReportDetailOpen, setCloseReportDialog, setSelectedReportDetailClosed, handleSubmit, register, reportsList }} />
          </Grid>
        </Grid>
      </Grid>
      <SpDialog
        style={{ padding: '1%' }}
        open={closeReportDialog.status}
        setOpen={() => setCloseReportDialog({ report: null, status: false })}
        title={'Chiudi report'}
      >
        <Grid
          container
          direction="column"
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
            <SpText variant="text">{'Sei sicuro di voler chiudere questa segnalazione?'}</SpText>
          </Grid>
          <Grid
            item
            container
            xs={12}
            alignItems={'flex-start'}
          >
            <Grid
              item
              xs={4}
            >
              <SpButton
                text={'SI'}
                buttonType="accept"
                onClick={() => forcedReportEnding()}
              />
            </Grid>
            <Grid
              item
              xs={4}
              style={{ marginBottom: '1%' }}
            >
              <SpButton
                text={'NO'}
                buttonType="accept"
                onClick={() => {
                  setCloseReportDialog({ report: null, status: false });
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </SpDialog>
      <SpDialog
        style={{ padding: '1%' }}
        open={selectedReportDetailOpen.status}
        setOpen={() => setSelectedReportDetailOpen({ report: null, status: false })}
        title={'Dettaglio report'}
      >
        <StationOpenedReportDetailDialog
          selectedReport={selectedReportDetailOpen.report}
          {...{ valueTab, setValueTab, updateCurrentReport, setSelectedReportDetailOpen, handleSubmit, register, setValue, reset }}
        />
      </SpDialog>
      <SpDialog
        style={{ padding: '1%' }}
        open={selectedReportDetailClosed.status}
        setOpen={() => setSelectedReportDetailClosed({ report: null, status: false })}
        title={'Dettaglio report chiuso'}
      >
        <StationClosedReportDetailDialog
          selectedReport={selectedReportDetailClosed.report}
          {...{ valueTab, setValueTab, setSelectedReportDetailClosed, handleSubmit, register }}
        />
      </SpDialog>
    </>
  );
};

export default withSnackbar(StationReports);
